import { Dialog } from '../controls/dialog.js';
import { UIBlocker } from '../ui/ui_blocker.js';
import { AsapPromise } from '../util/asap_promise.js';
import { AccountFormMixin } from './account_form_mixin.js';

/**
 * Login dialog.
 */
class LoginDialog extends AccountFormMixin(Dialog) {
  show() {
    this.messageBoxElement.hidden = true;
    this.formElement.reset();
    super.show();
    this.emailElement.focus();

    return (this.#loginPromise = new AsapPromise());
  }

  initialize() {
    super.initialize();

    this.setMessageBox();
    this.setLoginListeners();
  }

  accepted() {
    this.#loginPromise.resolve(true);
  }

  cancelled() {
    this.#loginPromise.resolve(false);
  }

  checkValidity() {
    return UIBlocker(this.login());
  }

  static tagName = 'login-dialog';
  static titleMarkup = `Log in`;
  static bodyMarkup = `
    <div class='msg' hidden></div>
    <form class='default' method='post'>
      <input placeholder='email' type='email' autocomplete='username' required><br>
      <input placeholder='password' type='password' autocomplete='current-password'
             required><br>
    </form>
    <span class='note'>If no account yet, please
      <a class='signup-link' href='/signup'>sign up</a>.
    </span>
  `;

  static buttons = {
    accept: {
      label: 'Log in',
      default: true,
    },
    cancel: {
      label: 'Close',
    },
  };

  #loginPromise;
}

LoginDialog.defineCustomElement();

export { LoginDialog };
